import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { CommonService } from '../../../../shared/common.service';
import { DividendsComponentService } from '../dividends/service/dividends-component.service';
import * as CryptoJS from 'crypto-js';
import Swal from 'sweetalert2';
import { Observable } from 'rxjs';
import { SideNavService } from '../../../../theme/layout/admin/navigation/service/side-nav.service';

@Component({
  selector: 'app-capital-commitments',
  templateUrl: './capital-commitments.component.html',
  styleUrls: ['./capital-commitments.component.scss']
})
export class CapitalCommitmentsComponent implements OnInit{
  CapitalCommitments: FormGroup;
  isJump: any;
  NormalRoutng: boolean;
  showBubbledata:any
  constructor(private formbuilder: FormBuilder, private service: DividendsComponentService, public commonService: CommonService, private router: Router, public sidenav: SideNavService) {

  }
  ngOnInit() {
    debugger
    this.commonService.getIncomeStatementsHeaders();
    this.Createformgroup();
    this.Getdata();
    this.clearfield();
    this.isJump = localStorage.getItem('isJump');
    if (localStorage.getItem("SubmitStatus") == "true")
      this.CapitalCommitments.disable()

    //this.commonService.Showbubble.subscribe((data) => {
    //  if (data) {
        this.commonService.getImportPageSelectionData(this.commonService.AccountTemplateId, CryptoJS.AES.decrypt(localStorage.getItem("companyId"), "APS").toString(CryptoJS.enc.Utf8), CryptoJS.AES.decrypt(localStorage.getItem("APPeriodId"), "APS").toString(CryptoJS.enc.Utf8)).subscribe((data) => {
          this.commonService.showBubble = data[0].ImportStatus
          if (this.commonService.showBubble) {
            this.sidenav.setShowBubble(true);
            this.getlastyeardata()
          }
        })
    //  }
    //  else {
    //    this.showBubbledata = null
    //  }
    //})

  }
  Createformgroup() {
    this.CapitalCommitments = this.formbuilder.group({
      AdditionalInformation: new FormControl(),
      PageName: new FormControl(),
      APPeriodId: new FormControl(),
      CreatedBy: new FormControl(),
      CreatedDate: new FormControl(),
      ModifiedBy: new FormControl(),
      ModifiedDate: new FormControl(),
    })
  }

  clear: any
  clearfield() {
    debugger
    this.clear = this.commonService.clearAllFields.subscribe((data: boolean) => {
      if (data) {
        this.CapitalCommitments.reset()
      }
    })
  }
  Savemethod() {
    debugger;
    var data = this.CapitalCommitments.getRawValue();
    data.APPeriodId = CryptoJS.AES.decrypt(localStorage.getItem("APPeriodId"), "APS").toString(CryptoJS.enc.Utf8)
    data.PageName = "CapitalCommitments";
    this.service.insertsinglestatementdetails(data).subscribe((data: any) => {
      this.CapitalCommitments.markAsPristine();

      if (this.NormalRoutng)
        return true;
      var nextPage;
      nextPage = this.commonService.getNextNoteSelection("Capital commitments", this.commonService.NotesList)
      if (this.isJump == 'true')
        this.router.navigate(['/notes'])
      else if (nextPage == "capitalcommitments") {
        nextPage = this.commonService.getNextPageSelection("Notes", this.commonService.allPagesdata)
        this.router.navigate([nextPage]);
      }
      else {
        this.router.navigate([nextPage]);
      }
    })
  }
  Back() {
    this.CapitalCommitments.markAsPristine();
    var backpage;
    if (this.isJump == 'true')
      this.router.navigate(['/notes'])
    else {
      backpage = this.commonService.getBackSelection("Capital commitments", this.commonService.NotesList)
      this.router.navigate([backpage]);
    }
  }
  Getdata() {
    debugger;
    var id = CryptoJS.AES.decrypt(localStorage.getItem("APPeriodId"), "APS").toString(CryptoJS.enc.Utf8)
    var PageName = "CapitalCommitments";
    this.service.Getsinglestatementdetails(id, PageName).subscribe((data: any) => {
      this.CapitalCommitments.patchValue(data);
      this.commonService.getNotesData();
    })
  }

  getlastyeardata() {
    var id = CryptoJS.AES.decrypt(localStorage.getItem("APPeriodId"), "APS").toString(CryptoJS.enc.Utf8)
    var PageName = "CapitalCommitments";
    this.service.Getsinglestatementdetails_LY(id, PageName).subscribe((data: any) => {
      this.showBubbledata = data;
    })
  }

  canDeactivate(): Observable<boolean> | Promise<boolean> | boolean {
    debugger;
    if (this.CapitalCommitments.dirty) {
      return Swal.fire({
        title: "Andica Accounts Production",
        html: "<span style='font-weight:900'>You have unsaved data.</span> <br><span>Do you want to save your changes before leaving?</span>",
        icon: "warning",
        confirmButtonText: "Save Changes",
        showCancelButton: true,
        cancelButtonText: "Discard Changes",
        allowOutsideClick: false
      }).then((result) => {
        if (result.value) {
          debugger;
          this.NormalRoutng = true;
          this.Savemethod();
        }
        else {
          return true;
        }
      })
    }
    else if (this.commonService.routeToCompanyList) {
      return true
    }
  }

  TotalBack() {
    debugger;
    this.commonService.DisplayAccountingPeriodlist = true;
    this.router.navigate(['/business']);

  }
}
